var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83337 19.0003C6.83337 23.4001 6.83337 25.6 8.20021 26.9668C9.56704 28.3337 11.7669 28.3337 16.1667 28.3337C20.5665 28.3337 22.7664 28.3337 24.1332 26.9668C25.5 25.6 25.5 23.4001 25.5 19.0003C25.5 14.6006 25.5 12.4007 24.1332 11.0338C22.7664 9.66699 20.5665 9.66699 16.1667 9.66699C11.7669 9.66699 9.56704 9.66699 8.20021 11.0338C6.83337 12.4007 6.83337 14.6006 6.83337 19.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.2732 1.66699L12.0674 3.14716C13.0225 3.93504 13.5 4.32898 13.5 4.81851L12.1667 4.81851C7.13835 4.81851 4.62419 4.81851 3.0621 6.3806C1.5 7.9427 1.5 10.4569 1.5 15.4852V16.3337",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate_right.fc77ef0c9899fabf2d7ce830f1e9229c.svg";
export { ForwardRef as ReactComponent };